import moment from 'moment-timezone'

const getDayName = (date) => {
  if (!date) return ''
  return moment(date).format('dddd')
}

const getWeekOfMonth = (date) => {
  if (!date) return 1
  const momentDate = moment(date)
  const firstDayOfMonth = momentDate.clone().startOf('month')
  const dayOfMonth = momentDate.date()
  const firstDayOfWeek = firstDayOfMonth.day()
  return Math.ceil((dayOfMonth + firstDayOfWeek) / 7)
}

const getWeekName = (weekNumber) => {
  const weekNames = {
    1: 'first',
    2: 'second',
    3: 'third',
    4: 'fourth',
    5: 'fifth',
  }
  return weekNames[weekNumber] || 'first'
}

// Calculate how often sessions should occur (in weeks or months)
const calculatePatternInterval = (coachDetails) => {
  if (!coachDetails) return null

  const {
    typeOfCoachingCycle,
    numberOfCoachingCycle,
    sessionPerCoachingCycle,
  } = coachDetails

  if (
    !typeOfCoachingCycle ||
    !numberOfCoachingCycle ||
    !sessionPerCoachingCycle
  ) {
    return null
  }

  const cycleType = String(typeOfCoachingCycle).toLowerCase()
  let weeksPerSession = 0
  let monthsPerSession = 0

  if (cycleType === 'weekly') {
    weeksPerSession = numberOfCoachingCycle / sessionPerCoachingCycle
    monthsPerSession = weeksPerSession / 4 // Approximate
  } else if (cycleType === 'monthly') {
    const cycleWeeks = numberOfCoachingCycle * 4 // Approximate
    weeksPerSession = cycleWeeks / sessionPerCoachingCycle
    monthsPerSession = numberOfCoachingCycle / sessionPerCoachingCycle
  } else if (cycleType === 'yearly') {
    const cycleMonths = numberOfCoachingCycle * 12
    monthsPerSession = cycleMonths / sessionPerCoachingCycle
    weeksPerSession = monthsPerSession * 4 // Approximate
  }

  return {
    weeksPerSession,
    monthsPerSession,
  }
}

export const getRecurringPatternOptions = (coachDetails, selectedDate) => {
  if (!selectedDate) return []

  const dayName = getDayName(selectedDate)
  const weekOfMonth = getWeekOfMonth(selectedDate)
  const weekName = getWeekName(weekOfMonth)
  const options = []

  // If coachDetails is available, use it to determine patterns
  if (coachDetails) {
    const { isBillingIndefinite } = coachDetails

    if (isBillingIndefinite === false) {
      const intervalData = calculatePatternInterval(coachDetails)

      if (intervalData !== null) {
        const { weeksPerSession, monthsPerSession } = intervalData

        if (weeksPerSession < 5) {
          const roundedWeeks = Math.round(weeksPerSession)

          if (roundedWeeks === 1) {
            options.push({
              value: 'weekly',
              label: `Weekly on ${dayName}`,
            })
          } else if (roundedWeeks === 2) {
            options.push({
              value: 'alternate',
              label: `Every Alternate ${dayName}`,
            })
          } else if (roundedWeeks === 3) {
            options.push({
              value: 'every-3-weeks',
              label: `Every 3 weeks on ${dayName}`,
            })
          } else {
            options.push({
              value: `every-${roundedWeeks}-weeks`,
              label: `Every ${roundedWeeks} weeks on ${dayName}`,
            })
          }
        } else {
          const roundedMonths = Math.round(monthsPerSession)

          if (roundedMonths === 1) {
            options.push({
              value: 'monthly',
              label: `Monthly on the ${weekName} ${dayName}`,
            })
          } else if (roundedMonths === 2) {
            options.push({
              value: 'bi-monthly',
              label: `Every 2 months on the ${weekName} ${dayName}`,
            })
          } else if (roundedMonths === 3) {
            options.push({
              value: 'quarterly',
              label: `Every 3 months on the ${weekName} ${dayName}`,
            })
          } else {
            options.push({
              value: `every-${roundedMonths}-months`,
              label: `Every ${roundedMonths} months on the ${weekName} ${dayName}`,
            })
          }
        }
      } else {
        options.push(
          {
            value: 'weekly',
            label: `Weekly on ${dayName}`,
          },
          {
            value: 'alternate',
            label: `Every Alternate ${dayName}`,
          },
          {
            value: 'monthly',
            label: `Monthly on the ${weekName} ${dayName}`,
          },
        )
      }
    } else {
      // isBillingIndefinite === true
      options.push(
        {
          value: 'weekly',
          label: `Weekly on ${dayName}`,
        },
        // {
        //   value: 'alternate',
        //   label: `Every Alternate ${dayName}`,
        // },
        {
          value: 'monthly',
          label: `Monthly on the ${weekName} ${dayName}`,
        },
        {
          value: 'bi-weekly',
          label: `Every 2 weeks on ${dayName}`,
        },
        {
          value: 'every-3-weeks',
          label: `Every 3 weeks on ${dayName}`,
        },
      )
    }
  } else {
    // Fallback: No coachDetails - show default options
    options.push(
      {
        value: 'weekly',
        label: `Weekly on ${dayName}`,
      },
      {
        value: 'alternate',
        label: `Every Alternate ${dayName}`,
      },
      {
        value: 'monthly',
        label: `Monthly on the first ${dayName}`,
      },
    )
  }

  return options
}
